import { render } from "./EditEmergencyContact.vue?vue&type=template&id=d8cf697c"
import script from "./EditEmergencyContact.vue?vue&type=script&lang=js"
export * from "./EditEmergencyContact.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__